const exitInfo = {
  description:
    'EXOD tokens are a blockchain-based representation of shares of Exodus common stock.',
  reddit: 'https://www.reddit.com/r/ExodusWallet/',
  twitter: 'https://twitter.com/exodus_io',
  website: 'https://support.exodus.com/article/1564-introducing-exit-tokens',
}

export default [
  {
    name: 'eden',
    displayName: 'Eden',
    decimals: 0,
    ticker: 'EDEN',
    assetIndex: 206_679_046,
    info: exitInfo,
    primaryColor: '#3370ff',
    gradientColors: ['#00bfff', '#6619ff'],
    gradientCoords: { x1: '89.933%', y1: '100%', x2: '10.067%', y2: '0%' },
  },
  {
    name: 'exit',
    displayName: 'Exodus Shares',
    decimals: 0,
    ticker: 'EXIT',
    displayTicker: 'EXOD',
    assetIndex: 213_345_970,
    info: exitInfo,
    primaryColor: '#3370ff',
    gradientColors: ['#00bfff', '#6619ff'],
    gradientCoords: { x1: '89.933%', y1: '100%', x2: '10.067%', y2: '0%' },
  },
  {
    name: 'gems_algorand_60d192b2',
    displayName: 'AlgoGems',
    decimals: 6,
    ticker: 'GEMSalgorand60D192B2',
    displayTicker: 'GEMS',
    assetIndex: 230_946_361,
    info: {
      description:
        'GEMS is the native token for the decentralized NFT marketplace Algogems, which offers minting and listing NFTs for free. The token is used for governance and rewarding users.',
      reddit: 'https://reddit.com/r/Algogems',
      twitter: 'https://twitter.com/AlgogemsNFT',
      website: 'https://www.algogems.io/',
      telegram: 'https://t.me/AlgogemsLounge',
    },
    primaryColor: '#008EF7',
    gradientColors: ['#008EF7', '#5FBBFF'],
    gradientCoords: { x1: '20.125%', y1: '14.449%', x2: '20.125%', y2: '10.88%' },
  },
  {
    name: 'opul_algorand_35471831',
    displayName: 'Opulous',
    decimals: 10,
    ticker: 'OPULalgorand35471831',
    displayTicker: 'OPUL',
    assetIndex: 287_867_876,
    info: {
      description:
        'OPUL bridges artists and investors with the Opulous platform. Artists can take loans and mint MFTs (Musical Fungible Tokens). And buyers can invest in the MFTs to earn royalty income or trade them for other MFTs.',
      twitter: 'https://twitter.com/opulousapp',
      website: 'https://opulous.org/',
      telegram: 'https://t.me/opulousapp',
    },
    primaryColor: '#FF5500',
    gradientColors: ['#FF5500', '#FF9B69'],
    gradientCoords: { x1: '3%', y1: '8.498%', x2: '41.043%', y2: '26.736%' },
  },
  {
    name: 'smile_algorand',
    displayName: 'Smile Coin',
    decimals: 6,
    ticker: 'SMILE',
    assetIndex: 300_208_676,
    info: {
      description:
        'SMILE powers the decentralized gaming network Smile Coin, which brings Web3 functionality to gaming platforms. It offers low fees, fast transactions, improved transparency, and more.',
      reddit: 'https://reddit.com/r/SmileCoin',
      twitter: 'https://twitter.com/SmilecoinUS',
      website: 'https://smilecoin.us/',
      telegram: 'https://t.me/smilecoin_invite',
    },
    primaryColor: '#21DBCC',
    gradientColors: ['#2ADACC', '#21DBCC'],
    gradientCoords: { x1: '3%', y1: '8.498%', x2: '41.043%', y2: '26.736%' },
  },
  {
    name: 'stbl_algorand',
    displayName: 'AlgoStable',
    decimals: 6,
    ticker: 'STBL',
    assetIndex: 465_865_291,
    info: {
      description:
        'STBL is a decentralized stablecoin pegged to the US dollar. This over-collateralized stablecoin bridges lending and borrowing on the Algofi protocol, which offers lower transaction fees than other stablecoins.',
      website: 'https://docs.algofi.org/algofi-lending/stbl',
    },
    primaryColor: '#8C52FF',
    gradientColors: ['#BE9DFF', '#8C52FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'tinyusdc_algorand',
    displayName: 'Tinyman USDC',
    decimals: 6,
    ticker: 'USDCTINY',
    displayTicker: 'USDC',
    assetIndex: 552_647_097,
    primaryColor: '#FFFFFF',
    gradientColors: ['#FFFFFF', '#00FFFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'usdcoin_algorand',
    displayName: 'USDC',
    decimals: 6,
    ticker: 'USDCALGO',
    displayTicker: 'USDC',
    assetIndex: 31_566_704,
    primaryColor: '#3E90E8',
    gradientColors: ['#3E90E8', '#2775CA'],
    gradientCoords: { x1: '102%', y1: '101%', x2: '0%', y2: '0%' },
  },
  {
    name: 'vest_algorand_120e7149',
    displayName: 'Vestige',
    decimals: 6,
    ticker: 'VESTalgorand120E7149',
    displayTicker: 'VEST',
    assetIndex: 700_965_019,
    info: {
      description:
        'The VEST token is used to access features on Vestige, a data platform offering real-time charting, trading, and portfolio tracking in the Algorand ecosystem.',
      reddit: 'https://www.reddit.com/r/vestigefi/',
      twitter: 'https://twitter.com/vestigefi',
      website: 'https://vestige.fi/announcement',
    },
    primaryColor: '#2078E9',
    gradientColors: ['#2078E9', '#57A1FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'xet_algorand_a17ef051',
    displayName: 'Xfinite Entertainment Token',
    decimals: 9,
    ticker: 'XETalgorandA17EF051',
    displayTicker: 'XET',
    assetIndex: 283_820_866,
    info: {
      description:
        'The XET token is used in Xfinite, a decentralized entertainment ecosystem that wants to change how people interact with content. It uses watch-to-earn gamification, connects creators and their audience, and provides an NFT marketplace for creators.',
      twitter: 'https://twitter.com/XfiniteOfficial',
      website: 'https://xfiniteofficial.medium.com/',
      telegram: 'https://t.me/xfiniteofficialnews',
    },
    primaryColor: '#5FAEFF',
    gradientColors: ['#007EFE', '#5FAEFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'yieldly_algorand',
    displayName: 'Yieldly',
    decimals: 6,
    ticker: 'YLDY',
    assetIndex: 226_701_642,
    info: {
      description:
        'YLDY powers the DeFi ecosystem Yieldly, which aims to offer reward and staking features, an automated market maker, and NFT-powered GameFi all on Algorand.',
      twitter: 'https://twitter.com/YieldlyFinance',
      website: 'https://yieldly.finance/',
      telegram: 'https://t.me/yieldly',
    },
    primaryColor: '#FB3EF3',
    gradientColors: ['#FF9AFB', '#FB3EF3'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
]
